import { PersonAdd } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { FC } from 'react';
import { usePatientProfileWidget } from '../hooks/use-patient-profile-widget';
import { ContactInfo } from './contact-info/contact-info';
import { HeaderWrapper } from './header.styles';

export const PatientProfileHeader: FC = () => {
  const { isSkinnyProfile } = usePatientProfileWidget();

  return (
    <HeaderWrapper>
      <ContactInfo />
      {isSkinnyProfile && (
        <Alert severity="success" icon={<PersonAdd />} sx={{ display: 'flex', alignItems: 'center' }}>
          {`This is a new patient for this location. We only have general information about them. To see more information choose another location above.`}
        </Alert>
      )}
    </HeaderWrapper>
  );
};
